/**
 * Gruppenüberschriften für eine Ticketfolge (#278) — dieselbe Regel in der
 * Vorbereitung, in der Agenda-Spalte des Cockpits und auf der Agenda-Folie.
 *
 * Eine Überschrift steht vor jedem Eintrag, dessen Gruppe sich von der des
 * Vorgängers unterscheidet. Das sind LÄUFE, keine Eimer: Wer in der
 * Vorbereitung ein Ticket aus seiner Gruppe hinausschiebt, bekommt die
 * Überschrift dort ein zweites Mal — statt dass die Reihenfolge, die er
 * gerade bewusst gesetzt hat, still wieder nach Gruppen sortiert würde.
 *
 * Ohne Gruppe (Liste war ungruppiert, Nachzügler ohne Etikett) gibt es keine
 * Überschrift; ein Eintrag ohne Gruppe nach einem mit Gruppe beendet den Lauf
 * still.
 */
export function groupHeaders(
  keys: readonly string[],
  groupOf: (key: string) => string | undefined,
): Map<number, string> {
  const headers = new Map<number, string>();
  let previous: string | undefined;
  keys.forEach((key, i) => {
    const group = groupOf(key);
    if (group !== undefined && group !== previous) headers.set(i, group);
    previous = group;
  });
  return headers;
}
